<mat-dialog-content>
  <div [innerHTML]="content"></div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Chiudi</button>
</mat-dialog-actions>
